<template>
  <div>
    <div
      v-for="item in items"
      :key="item.account"
      class="content"
    >
      <h5>{{ item.bankCode }} - {{ item.bankName }}</h5>
      <div class="grid">
        <div>
          <p>
            Satus de validação:
            <span>{{ validationStatusMask(item.validationStatus) }}</span>
          </p>
          <p>
            Conta liquidação:
            <span>{{ booleanMask(item.contaLiquidacao) }}</span>
          </p>
          <p>
            Criado em: <span>{{ dateMask(item.createdAt) }}</span>
          </p>
        </div>
        <div>
          <p>
            Titular: <span>{{ item.accountHolder }}</span>
          </p>
          <p>
            CPF/CNPJ: <span>{{ documentMask(item.document) }}</span>
          </p>
          <div class="flex">
            <p>Agência: <span>{{ item.agency }}</span></p>
            <p>Conta: <span>{{ item.account }} - {{ item.accountDigit }}</span></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BankAccountRequest from 'App/users/services/BankAccountService';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import DocumentFilter from '@/app/arch/filters/DocumentFilter';
import DateMixin from '@/app/arch/mixins/DateMixin';

export default {
  name: 'ClientBankAccount',
  filters: [DocumentFilter],
  mixins: [ServiceMixin, DateMixin],
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    requestClass: BankAccountRequest,
    payload: [],
    loading: false,
  }),
  computed: {
    clientId() {
      return this.value;
    },
    items() {
      return this.payload;
    },
  },
  watch: {
    clientId: {
      immediate: true,
      handler(id) {
        if (Number(id) > 0) {
          this.makeRequest();
        }
      },
    },
  },
  methods: {
    makeRequest() {
      this.handleLoading();
      this.callService(
        this.requestClass.list({
          ClientId: this.clientId,
          PerPage: 1000,
        }),
        (response) => {
          this.handleLoading();
          if (this.hasData(response)) {
            this.payload = response.data.data;
          }
        },
      );
    },
    handleLoading() {
      this.loading = !this.loading;
    },
    dateMask(value) {
      return this.formatDate(value, 'DD / MM / YYYY');
    },
    booleanMask(value) {
      if (typeof value !== 'boolean') return String(value);
      if (value) return 'Sim';
      return 'Não';
    },
    validationStatusMask(value) {
      switch (value) {
        case 'Invalid':
          return 'Inválido';
        case 'NotValidated':
          return 'Não validado';
        case 'Pending':
          return 'Pendente';
        case 'Validated':
          return 'Validado';
        default:
          return value;
      }
    },
    documentMask(value) {
      return DocumentFilter(value);
    },
  },
};
</script>

<style scoped>
  .content {
    border-bottom: 1px solid #f1f3f5;
    padding-bottom: 32px;
  }
  .content + .content {
    margin-top: 16px;
  }

  .grid {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    grid-column-gap:24px;
    grid-row-gap: 16px;
  }

  .flex {
    display: flex;
    align-items: center;
    justify-content: start;
    column-gap: 12px;
  }

  p {
    margin-top: 16px;
    font-size: 12px;
    line-height: 16px;
    color: #69737D;
  }

  p > span {
    font-weight: 700;
  }

  h5 {
    font-size: 14px;
    line-height: 24px;
    font-weight: 700;
    color: #365C7D;
  }
</style>
